import { configureStore } from "@reduxjs/toolkit";
import alertReducer from "./reducers/alert-slice";
import companyReducer from "./reducers/company-slice";
import deliveryReducer from "./reducers/delivery-slice";
import loadingReducer from "./reducers/loading-slice";
import locationReducer from "./reducers/location-slice";
import profileReducer from "./reducers/profile-slice";
import scheduleReducer from "./reducers/schedule-slice";
import userReducer from "./reducers/user-slice";
import routingReducer from "./reducers/routing-slice";
import thunk from 'redux-thunk';

export const store = configureStore({
  reducer: {
    alert: alertReducer,
    user: userReducer,
    company: companyReducer,
    profile: profileReducer,
    location: locationReducer,
    delivery: deliveryReducer,
    schedule: scheduleReducer,
    loading: loadingReducer,
    routing: routingReducer,
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
